<template>
  <span>
    <font-awesome-icon :icon="icon" :class="`has-text-${iconVariation} mr-2`"/>
    {{ finalDisplayAs }}
    <b-tooltip v-if="hideLink !== true" type="is-dark" label="Show device info">
      <router-link :to="{name:'subject', params: { id }}">
        <font-awesome-icon icon="circle-info" class="ml-2 has-text-dark" />
      </router-link>
    </b-tooltip>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
import { deviceIcon, iconVariation } from '@/services/devices'

export default {
  props: {
    id: String,
    displayAs: String,
    hideLink: Boolean,
  },
  computed: {
    ...mapGetters('deviceCache', ['owners']),
    icon () { return deviceIcon(this.id) },
    iconVariation () { return iconVariation(this.id) },
    finalDisplayAs () {
      if (this.id in this.owners) return this.owners[this.id]
      if ((this.displayAs || '').length > 0) return this.displayAs
      return this.id
    }
  }
}
</script>